import { LightbulbIcon, ShieldCheckIcon, LightningIcon } from '@phosphor-icons/react'
import styles from './ValueSection.module.scss'

export const ValueSection = () => {
    return (
        <div className={styles.valueSection}>
            <div className={styles.logo}>
                <a href="https://scoopanalytics.com/">
                    <img
                        src="https://cdn.prod.website-files.com/65fdc9041545b81c2e66e5ac/66294c942995cf5e1ba7eb96_Logo%20Black.svg"
                        alt="Scoop Analytics"
                    />
                </a>
            </div>

            <h1>
                AI Analytics That Actually <span className={styles.highlight}>Thinks</span>
            </h1>

            <p className={styles.subtitle}>
                Ask questions in plain English. Get predictions, segments, and insights with clear
                explanations. One-click to boardroom-ready presentations.
            </p>

            <ul className={styles.benefitsList}>
                <li>
                    <strong>Natural language interface:</strong> Ask "which customers will churn?"
                    and get answers with charts, predictions, and context
                </li>
                <li>
                    <strong>Real machine learning:</strong> Discover hidden segments, predict
                    outcomes, identify key drivers—with transparent reasoning
                </li>
                <li>
                    <strong>Built for teams:</strong> Share insights instantly via Slack or
                    web—everyone sees the same numbers
                </li>
                <li>
                    <strong>Connect anything:</strong> 100+ integrations including Salesforce,
                    HubSpot, Google Analytics—setup in minutes
                </li>
            </ul>

            <div className={styles.trustSection}>
                <div className={styles.trustItem}>
                    <LightbulbIcon size={18} weight="regular" />
                    <span>Shows exactly how it reached every conclusion—no black box AI</span>
                </div>
                <div className={styles.trustItem}>
                    <ShieldCheckIcon size={18} weight="regular" />
                    <span>SOC 2 Type II certified—enterprise-grade security</span>
                </div>
                <div className={styles.trustItem}>
                    <LightningIcon size={18} weight="regular" />
                    <span>Live in 5 minutes—no IT, no data warehouse, no SQL</span>
                </div>
            </div>
        </div>
    )
}
